import type React from 'react';

interface RefereeCardProps {
  color: 'yellow' | 'red';
}

export const RefereeCard: React.FC<RefereeCardProps> = ({ color }) => {
  const backgroundColor = color === 'yellow' ? '#facc15' : '#dc2626';

  return (
    <div
      style={{
        width: '12px',
        height: '16px',
        backgroundColor,
        border: '1px solid #000',
      }}
    />
  );
};
